
export class MotivoCancelamento {

  id: number = 0;

  descricao: string = '';

}
